import axios from "./index";

export default {
  findUser(callback, params) {
    axios.get("/api/v1/users", {
      params: {
        user_id: params.userId
      }
    }).then(response => {
      callback(response.data);
    }).catch(error => {
      console.log(error);
    });
  },

  updateUser(params, successCallback, failureCallback) {
    const user = { notice: params.notice };
    // 運営権限以外が operator_notice を送ると 403 になるため、指定されたときだけ送る
    if (params.operatorNotice !== undefined) user.operator_notice = params.operatorNotice;
    axios.put("/api/v1/users/" + params.id, {
      user
    }, {
      headers: { "Content-Type": "application/json" }
    }
    ).then(() => {
      successCallback();
    }).catch(error => {
      console.log(error);
      failureCallback(error);
    });
  }
};
